import React, { HTMLAttributes, ReactNode, useEffect, useState } from 'react'
import { IWithDropdownProps, withDropdown } from '../../../lib/hoc/WithDropdown'
import { IOption } from '../search-input/BpSearchInput'
import { Input } from 'antd'
import { IconSearch } from '../../icons/IconSearch'
import {
  DropdownPositioner,
  TDropdownPosition,
} from '../../../../lib/ui/dropdown-positioner/component/DropdownPositioner'

export interface IFilterDropParams extends IWithDropdownProps {
  children?: ReactNode | undefined
  disabled?: boolean
  options?: IOption[]
  value?: string
  onChange?: (value: string | null) => void
  height?: number
  showSearch?: boolean
  bottomSection?: ReactNode
  horizontalPosition?: 'left' | 'right'
  verticalPosition?: TDropdownPosition
}

const Drop = ({
  children,
  disabled = false,
  options,
  value,
  open,
  onToggle,
  onChange,
  height = 200,
  showSearch = false,
  bottomSection,
  horizontalPosition = 'left',
  verticalPosition = 'auto',
}: IFilterDropParams & HTMLAttributes<HTMLElement>) => {
  const [state, setState] = useState(value)
  const [search, setSearch] = useState('')
  const [isHidden, setIsHidden] = useState(!open)

  useEffect(() => {
    setState(value)
  }, [value])

  useEffect(() => {
    open ? setIsHidden(false) : setTimeout(() => setIsHidden(true), 150)
  }, [open])

  return (
    <div className='relative table w-full select-none' data-drop-open={!isHidden || undefined}>
      <div className={'w-fit cursor-pointer'} onClick={onToggle}>
        {children}
      </div>
      <DropdownPositioner
        align={horizontalPosition === 'left' ? 'start' : 'end'}
        open={open && !disabled}
        position={verticalPosition}
        width={160}
      >
        <div className='flex flex-col overflow-hidden rounded-[6px] bg-white shadow-outline shadow-default'>
          {showSearch && !!options?.length && (
            <div className={'flex items-center border-b border-default/[0.07] py-[4px] pl-[12px]'}>
              <div className={'w-[14px]'}>
                <IconSearch color={'#00326D'} />
              </div>
              <Input
                className={
                  '!border-none text-[14px] text-focus-500 !outline-none transition-none focus:shadow-none'
                }
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          )}
          <div className={'flex flex-col overflow-auto'} style={{ maxHeight: height }}>
            {options
              ?.filter((option) => option.text.toLowerCase().includes(search.toLowerCase()))
              ?.filter((option) => !option.hidden)
              .map((option, index) => (
                <button
                  key={index}
                  className={`flex items-center justify-between px-[12px] py-[8px] text-left hover:bg-default-200 ${
                    option.value === state && 'bg-default-200'
                  }`}
                  onClick={() => {
                    setState(option.value)

                    onChange && onChange(option.value === state ? null : option.value)
                    onToggle && onToggle()
                  }}
                >
                  {option.text}
                  {option.icon && <div className={'max-w-[12px]'}>{option.icon}</div>}
                </button>
              ))}
            {!options?.length && (
              <div className='py-[12px] text-center text-[14px] text-aqua-300'>
                No results found
              </div>
            )}
          </div>
          {bottomSection && <div className={'border-t border-default/[0.07]'}>{bottomSection}</div>}
        </div>
      </DropdownPositioner>
    </div>
  )
}

export const DropOptions = withDropdown(Drop)
